import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = checking, false = no, obj = yes

  useEffect(() => {
    const token = localStorage.getItem("erp_token");
    if (!token) {
      setAdmin(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setAdmin(res.data))
      .catch(() => {
        localStorage.removeItem("erp_token");
        setAdmin(false);
      });
  }, []);

  const login = async (token, user) => {
    localStorage.setItem("erp_token", token);
    setAdmin(user);
  };

  const logout = () => {
    localStorage.removeItem("erp_token");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
